// extracted by mini-css-extract-plugin
export default {"roadmap":"Roadmap_roadmap__-MhTf","roadmap__wrapper":"Roadmap_roadmap__wrapper__CLqKe","roadmap__body":"Roadmap_roadmap__body__BoypI"};